import { ESubAdminRoles } from '../AdminIUser/constants';

export enum ISidebarTabs {
	RETAILERS = 'RETAILERS',
	CREDIT_NOTE = 'CREDIT_NOTE',
	INVOICES = 'INVOICES',
	SALESMEN = 'SALESMEN',
	PROMOTER = 'PROMOTER',
	PROMOTERSTOCKDETAILS = 'PROMOTER_STOCK_DETAILS',
	RETAIL_DISCOUNT = 'RETAIL_DISCOUNT',
	BEATS = 'BEATS',
	EXTERNAL_RETAILERS = 'EXTERNAL_RETAILERS',
	RETAILER_ENGINE = 'RETAILER_ENGINE'
}

export const D2RsubSectionsMap = {
	[ISidebarTabs.RETAILERS]: '1',
	[ISidebarTabs.CREDIT_NOTE]: '2',
	[ISidebarTabs.INVOICES]: '3',
	[ISidebarTabs.SALESMEN]: '4',
	[ISidebarTabs.PROMOTER]: '5',
	[ISidebarTabs.PROMOTERSTOCKDETAILS]: '6',
	[ISidebarTabs.RETAIL_DISCOUNT]: '7',
	[ISidebarTabs.BEATS]: '8',
	[ISidebarTabs.EXTERNAL_RETAILERS]: '9',
	[ISidebarTabs.RETAILER_ENGINE]: '10'
};

const sidebarUtilD2rDefault = {
	sideBar: [
		{
			key: '1',
			label: 'Retailers',
			icon: 'allSvgIcon',
			isNew: false
		},
		{
			key: '2',
			label: 'Credit Note',
			icon: 'allSvgIcon',
			isNew: false
		},
		{
			key: '3',
			label: 'Invoices',
			icon: 'allSvgIcon',
			isNew: false
		},
		{
			key: '4',
			label: 'Salesmen',
			icon: 'allSvgIcon',
			isNew: false
		},
		{
			key: '5',
			label: 'Promoter',
			icon: 'allSvgIcon',
			isNew: false
		},
		{
			key: '6',
			label: 'Promoter Stock Details',
			icon: 'allSvgIcon',
			isNew: false
		},
		{
			key: '7',
			label: 'Retail Discount',
			icon: 'allSvgIcon',
			isNew: false
		},
		{
			key: '8',
			label: 'Beats',
			icon: 'allSvgIcon',
			isNew: false
		},
		{
			key: '9',
			label: 'External Retailers',
			icon: 'allSvgIcon',
			isNew: false
		},
		{
			key: '10',
			label: 'Retailer Engine',
			icon: 'allSvgIcon',
			isNew: false
		}
	]
};

export const sidebarUtilD2r = (userRole: string) => {
	if (userRole === ESubAdminRoles.FIN_AUDITOR) {
		const findAuditAdminScreens = ['Credit Note', 'Invoices'];
		return {
			sideBar: sidebarUtilD2rDefault.sideBar.filter((S) => findAuditAdminScreens.includes(S.label))
		};
	}

	return sidebarUtilD2rDefault;
};

export const defaultScreenForRole = (userRole: string) => {
	if (userRole === ESubAdminRoles.FIN_AUDITOR) {
		return D2RsubSectionsMap[ISidebarTabs.CREDIT_NOTE];
	}

	return D2RsubSectionsMap[ISidebarTabs.RETAILERS];
};
